var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWsReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20311 -2061)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20311 2061)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15743.966 -3009.743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4540.251,5083.366a2.968,2.968,0,0,0-.906-2.134q-1.627-1.624-3.251-3.251a3.092,3.092,0,0,0-2.266-.958q-3.221,0-6.443,0a18.064,18.064,0,0,0-2.1.04,2.905,2.905,0,0,0-2.609,2.942c-.015.679,0,1.359,0,2.039q0,3.407,0,6.815h-.008q0,.968,0,1.935,0,3.311.008,6.623a3.609,3.609,0,0,0,.039.593,2.826,2.826,0,0,0,1.111,1.883,3.147,3.147,0,0,0,1.958.578q5.484-.007,10.969,0c.247,0,.5.006.744-.009a2.777,2.777,0,0,0,2.184-1.181,3.31,3.31,0,0,0,.562-2.014q0-5.394,0-10.789C-4540.245,5085.439-4540.236,5084.4-4540.251,5083.366Zm-5.291-3.859c0-.014,0-.028.012-.075l2.978,2.893c-.034.054-.078.032-.113.032h-2.734c-.085,0-.146.007-.146-.118C-4545.539,5081.329-4545.542,5080.417-4545.542,5079.506Zm3.1,17.827a3.009,3.009,0,0,1-.026.5.482.482,0,0,1-.511.476c-.167.016-.336.026-.5.026q-5.543,0-11.086,0a2.562,2.562,0,0,1-.576-.051.6.6,0,0,1-.518-.569,3.231,3.231,0,0,1-.029-.5v-17.053c0-.054,0-.108,0-.163a.731.731,0,0,1,.778-.792c.084-.007.169-.008.254-.008l6.367-.006a3.783,3.783,0,0,1,.476.009.293.293,0,0,1,.3.29,1.762,1.762,0,0,1,.006.222c0,1.092,0,2.182,0,3.274a1.323,1.323,0,0,0,.234.77,1.221,1.221,0,0,0,1.027.538c1.081.016,2.161.037,3.244.005.485-.015.579.078.576.561C-4542.454,5089.021-4542.435,5093.177-4542.442,5097.333Z",
    transform: "translate(0)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4510.454,5193.191a4.239,4.239,0,0,1-1.307,3.158,4.285,4.285,0,0,1-4.646,1,4.145,4.145,0,0,1-2.87-3.667,4.4,4.4,0,0,1,4-4.942c.374-.04.371.181.37.436,0,1.138.021,2.276-.011,3.414-.012.465.091.637.6.618,1.106-.042,2.214-.014,3.321-.014Z",
    transform: "translate(-34.863 -101.116)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4456.469,5173.234a4.362,4.362,0,0,1,4.366,4.341,2.794,2.794,0,0,1-.413.06c-1.167,0-2.334-.009-3.5.009-.344.006-.465-.088-.459-.451C-4456.456,5175.874-4456.469,5174.553-4456.469,5173.234Z",
    transform: "translate(-91.733 -87.088)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWsReport);
export default __webpack_public_path__ + "static/media/icon-ws-report.3fb2951e.svg";
export { ForwardRef as ReactComponent };